const informationusers = (state = [], action) => {
  switch (action.type) {
    case "INFOUSER":
      return {
        type: "INFOUSER",
        email: action.email,
        password: action.password,
        id: action.id,
        displayname: action.displayname,
        grupo: action.grupo,
        ramal: action.ramal,
        sipid: action.sipid,
        username: action.username,
        idsupervisao: action.idsupervisao,
        acessofila: action.acessofila,
        idgroup: action.idgroup,
        supervisor: action.supervisor,
        inanscount: action.inanscount,
        incallcount: action.incallcount,
        intmans: action.intmans,
        outanscount: action.outanscount,
        outcallcount: action.outcallcount,
        outtmans: action.outtmans,
        psdcount: action.psdcount,
        psdtma: action.psdtma,
        tmlogin: action.tmlogin !== undefined ? action.tmlogin : 0,
        atdauto: action.atdauto,
        enablecall: false,
        idin: action.idin,
        idout: action.idout,
        blockfuture: false,
        user_midias: action.user_midias,
        ad: action.ad,
        nameauth: action.nameauth,
        jobin_autoblocking: action.jobin_autoblocking,
        blockscreen: action.blockscreen,
        idblockdescription: action.idblockdescription,
        timeexceed: action.timeexceed,
        idblocksupervision: action.idblocksupervision,
        typeblock: action.typeblock,
        reasonblock: state.reasonblock,
        allowcallpickup: action.allowcallpickup,
        tmoutacw: action.tmoutacw,
        permdownload: action.permdownload,
        permreproduce: action.permreproduce,
        tmcallback: action.tmcallback,
        qtdecallback: action.qtdecallback,
        infoclinc2: [],
        numbersnc2: [],
        login_nc2: false,
        skill: action.skill,
        relatorio: action.relatorio,
        backendingdesk: action.backendingdesk,
        link_webchat: action.link_webchat,
        usedmodule: action.usedmodule,
        datalogin: action.datalogin,
        view_queue_interaction: action.view_queue_interaction,
        gerente: action.gerente,
        psdfbreak: action.psdfbreak,
        variables_integration: action.variables_integration,
        cadastros: action.cadastros,
        portal: action.portal,
        suporte: action.suporte,
        serviceout: action.serviceout,
        force_password_change: action.force_password_change,
        qualidade: action.qualidade,
        tokenLogin: action.tokenLogin ? action.tokenLogin : null,
        evaluation_feedback: action.evaluation_feedback,
        classificationcount: action.classificationcount,
        tmnoreply: action.tmnoreply,
        tmsdashboard: action.tmsdashboard,
        sending_audio: action.sending_audio,
        callback_midias: action.callback_midias,
        standby_permission: action.standby_permission,
        attach_sender_name: action.attach_sender_name,
        permissionsIngdesk: false,
        confirm_before_close: action.confirm_before_close,
        permissionWallet: null,
        max_agents_on_pause: action.max_agents_on_pause,
        checkpausa: action.checkpausa,
      };
    case "EDITUSER":
      return {
        ...state,
        type: "EDITUSER",
        email: action.email,
        password: action.password,
        id: action.id,
        displayname: action.displayname,
        grupo: action.grupo,
        ramal: action.ramal,
        sipid: action.sipid,
        username: action.username,
        idsupervisao: action.idsupervisao,
        acessofila: action.acessofila,
        idgroup: action.idgroup,
        supervisor: action.supervisor,
        inanscount: action.inanscount,
        incallcount: action.incallcount,
        intmans: action.intmans,
        outanscount: action.outanscount,
        outcallcount: action.outcallcount,
        outtmans: action.outtmans,
        psdcount: action.psdcount,
        psdtma: action.psdtma,
        tmlogin: action.tmlogin,
        atdauto: action.atdauto,
        enablecall: true,
        idin: action.idin,
        idout: action.idout,
      };
    case "ERRORLOGIN":
      return {
        ...state,
        error: true,
        email: action.email,
        id: action.id,
        server: action.server,
      };
    case "ERRORSENHA":
      return {
        ...state,
        error: true,
        email: action.email,
        id: action.id,
        hour: false,
      };

    case "ERRORHOUR":
      return { ...state, error: false, id: action.id, hour: true };

    case "AUTHSUCESS":
      return {
        ...state,
        type: "INFOUSER",
        email: action.email,
        password: action.password,
        id: action.id,
        sucess: true,
      };
    case "EDIT_CLIENT_WALLET":
      return { ...state, permissionWallet: action.permissionWallet };
    case "EDITUSER":
      return {
        ...state,
        type: "EDITUSER",
        email: action.email,
        password: action.password,
        id: action.id,
        displayname: action.displayname,
        grupo: action.grupo,
        ramal: action.ramal,
        sipid: action.sipid,
        username: action.username,
        idsupervisao: action.idsupervisao,
        acessofila: action.acessofila,
        idgroup: action.idgroup,
        supervisor: action.supervisor,
        inanscount: action.inanscount,
        incallcount: action.incallcount,
        intmans: action.intmans,
        outanscount: action.outanscount,
        outcallcount: action.outcallcount,
        outtmans: action.outtmans,
        psdcount: action.psdcount,
        psdtma: action.psdtma,
        tmlogin: action.tmlogin,
        atdauto: action.atdauto,
        enablecall: true,
        idin: action.idin,
        idout: action.idout,
      };
    case "ERRORLOGIN":
      return {
        ...state,
        error: true,
        email: action.email,
        id: action.id,
        server: action.server,
      };
    case "ERRORSENHA":
      return {
        ...state,
        error: true,
        email: action.email,
        id: action.id,
        hour: false,
      };

    case "ENABLECALL":
      return { ...state, enablecall: true, enablecallvoz: action.post };

    case "BLOCKSCREEN":
      return { ...state, blockscreen: action.blockscreen };

    case "EDIT_MODAL_PAUSE":
      return { ...state, showmodalpause: action.params };

    case "REASONBLOCK":
      return { ...state, reasonblock: action.reasonblock };

    case "EDIT_BLOCK_USER":
      return {
        ...state,
        idblocksupervision: action.idblocksupervision,
        idblockdescription: action.idblockdescription,
        typeblock: action.typeblock,
        reasonblock: action.reasonblock,
      };

    case "BLOCKFUTURE":
      return { ...state, blockfuture: action.blockfuture };

    case "BLOCKNC2":
      return {
        ...state,
        blocknc2: action.blocknc2,
        mensagemnc2: action.mensagemnc2,
      };

    case "EDIT_INDICATORS":
      return { ...state, outtmans: action.outtmans, intmans: action.intmans };

    case "EDIT_FUTURE_BREAK":
      return { ...state, psdfbreak: action.psdfbreak };

    case "EDIT_USER_SCHEDULE_REASONS_NC2":
      return { ...state, reasonsnc2: action.reasonsnc2, nc2schedule: false };

    case "EDIT_USER_SCHEDULE_NUMBERS_NC2":
      return { ...state, numbersnc2: action.numbersnc2 };

    case "EDIT_USER_SCHEDULE_CONFIRM_NC2":
      return {
        ...state,
        paramsnc2: action.paramsnc2,
        nc2schedule: action.nc2schedule,
      };

    case "EDIT_USER_INFO_NC2":
      return { ...state, infoclinc2: action.infoclinc2 };
    case "EDIT_USER_LOGIN_RESPONSE":
      return { ...state, loginresponse: action.loginresponse };
    case "EDIT_USER_LOGIN_NC2":
      return { ...state, login_nc2: action.login_nc2 };
    case "CHANGE_TOKEN_INGDESK_ENDPOINT":
      let token = action.token_ingdesk.replace(/\"/gm, "");
      return { ...state, token_ingdesk: token };
    case "EDIT_PERMISSIONS_INGDESK":
      const permissions = { ...action.permissions };
      return { ...state, permissionsIngdesk: permissions };
    default:
      return state;
  }
};

export default informationusers;
